let globalNotificationCallback = null;

export const setGlobalNotificationCallback = (callback) => {
    globalNotificationCallback = callback;
};

export const getGlobalNotificationCallback = () => {
    return globalNotificationCallback;
};

export const triggerNotification = (transactionId) => {
    if (globalNotificationCallback) {
        globalNotificationCallback(transactionId);
    }
};

export const handleTransactionResponse = async (response, store, generalActions) => {
    if (response.config && response.config.method === 'post') {
        const returnedId = response.headers['transaction-id'];
        if (returnedId) {
            console.log('Before dispatch, store state:', store.getState().general);
            await store.dispatch(generalActions.setLastTransactionId(returnedId));
            console.log('After dispatch, store state:', store.getState().general);

            triggerNotification(returnedId);
        }
    }
    return response;
};
